<template>
  <Row id="Salary">
    <Col :span="24" class="title">
      <TypographyTitle>{{$t('nav.name.SalaryManage')}}</TypographyTitle>
    </Col>
    <Col :span="24" class="content">
      <Row :gutter="[16,32]">
        <Col :span="24" >
          <Form :model="searchForm">
            <Row :gutter="30">
              <Col :xs="24" :sm="4">
                <FormItem :label="$t('public.name.search')" name="search">
                  <Input :placeholder="$t('public.name.search')" v-model:value="searchForm.search"></Input>
                </FormItem>
              </Col>
              <Col :xs="24" :sm="4">
                <FormItem :label="$t('salary.field.month')" name="month">
                  <DatePicker v-model:value="searchForm.month" valueFormat="YYYY-MM" picker="month" />
                </FormItem>
              </Col>
              <!-- <Col :xs="24" :sm="8">
                <FormItem :label="$t('public.field.status')">
                  <Select v-model:value="searchForm.status" :placeholder="$t('public.placeholder.please_select')">
                    <SelectOption :value="0">{{ $t('public.placeholder.please_select') }}</SelectOption>
                    <SelectOption :value="1">{{ $t('public.status.1') }}</SelectOption>
                    <SelectOption :value="2">{{ $t('public.status.2') }}</SelectOption>
                  </Select>
                </FormItem>
              </Col> -->
              <Col :xs="24" :sm="16" class="text-right">
                <Button type="primary" @click="search_submit">{{$t('public.name.search')}}</Button>&nbsp;
                <Button @click="search_reset">{{$t('public.name.reset')}}</Button>&nbsp;
                <!-- <Button type="primary" @click="generalSalary">{{
                    $t('salary.name.generalSalary')
                }}</Button>&nbsp;  -->
                <Button type="primary" @click="downloadCommissionPayment">{{$t('downloadCommissionPayment.name.title')}}</Button>&nbsp;
                <Button type="primary" @click="downloadAdvisor">{{$t('downloadCommissionPayment.name.downloadAdvisor')}}</Button>&nbsp;
                <Button type="primary" @click="downloadPaymentCommissionExcel">{{$t('downloadCommissionPayment.name.downloadPaymentCommissionExcel')}}</Button>&nbsp;
                <Button type="primary" @click="downloadAdvisorExcel">{{$t('downloadCommissionPayment.name.downloadAdvisorExcel')}}</Button>
              </Col>
            </Row>
          </Form>
        </Col>
        <Col :span="24">
        <Table :columns="columns" :dataSource="list" :scroll="{ x: true }" rowKey="idSal" :loading="loading" :pagination="tablePagination" @change="chang_page" :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }">
            <template #actionTitle>
              <span>
                {{$t("public.table.action")}}
                <Button v-if="checkPermission('SalaryManage.Add')" type="primary" size="small" shape="circle" @click="add()">
                  <PlusOutlined />
                </Button>
              </span>
            </template>
            <template #action="{text}">
              <div>
                <div class="pc-display">
                  <Button type="default" size="small" @click="detail(text)">{{$t("public.name.detail")}}</Button>
                  <span>&nbsp;</span>
                  <Button v-if="checkPermission('SalaryManage.Edit')" type="primary" size="small" @click="edit(text)">{{$t("public.name.edit")}}</Button>
                  <span>&nbsp;</span>
                  <Button v-if="checkPermission('SalaryManage.Delete')" type="primary" danger size="small" @click="del(text.idSal)">{{$t("public.name.del")}}</Button>
                  <span>&nbsp;</span>
                  <Button v-if="!text.paymentDate" type="primary" danger size="small" @click="confirm(text.idSal)">{{$t("public.name.confirm")}}</Button>
                  <span>&nbsp;</span>
                  <!-- <Button v-if="text.paymentDate" type="primary" size="small" @click="download(text.idSal)">{{$t("public.name.download")}}</Button> -->
                </div>
                
              </div>
            </template>
          </Table>
        </Col>
      </Row>
    </Col>
    <SalaryDetail ref="refSalaryDetail"></SalaryDetail>
    <SalaryEdit ref="refSalaryEdit" @updateList="get_list"></SalaryEdit>
    <NewSalaryEdit ref="refNewSalaryEdit" @updateList="get_list"></NewSalaryEdit>
    <GeneralSalary ref="refGeneralSalary" @updateList="get_list"></GeneralSalary>
    <DownloadCommissionPayment ref="refDownloadCommissionPayment" @selectedPrintDate="downloadCommissionPaymentStart"></DownloadCommissionPayment>
    <DownloadSelectPrintDate ref="refDownloadSelectPrintDate" @selectedPrintDate="downloadAdvisorStart"></DownloadSelectPrintDate>
  </Row>
</template>

<script>
import { createVNode } from "vue";
import { Row, Col, Table, Typography, Tag, Button, Dropdown, Menu, Modal, Form, Input, Select, message,DatePicker } from "ant-design-vue";
import { DownOutlined, ExclamationCircleOutlined, PlusOutlined } from "@ant-design/icons-vue";
import { SalaryList } from "@/api/SalaryList";
import { SalaryDelete } from "@/api/SalaryDelete"
import { SalaryConfirm } from "@/api/SalaryConfirm"
import { SalaryDownload } from "@/api/SalaryDownload"
import { SalaryExport } from "@/api/SalaryExport"
import { PaymentExportCommissionPaymentByIdSal } from "@/api/PaymentExportCommissionPaymentByIdSal"
import { PaymentDownCommissionPaymentByIdSal } from "@/api/PaymentDownCommissionPaymentByIdSal"
import SalaryDetail from "@/components/Home/SalaryDetail";
import SalaryEdit from "@/components/Home/SalaryEdit";
import NewSalaryEdit from "@/components/Home/NewSalaryEdit";
import GeneralSalary from "@/components/Home/GeneralSalary";
import DownloadCommissionPayment from "@/components/Home/DownloadCommissionPayment";
import DownloadSelectPrintDate from "@/components/Home/DownloadSelectPrintDate";
import moment from "moment";

export default {
  name: "SalaryManage",
  components: {
    Row,
    Col,
    Table,
    Form,
    FormItem: Form.Item,
    TypographyTitle: Typography.Title,
    Tag,
    Button,
    Input,
    Select,
    SelectOption: Select.Option,
    Dropdown,
    DownOutlined,
    PlusOutlined,
    ExclamationCircleOutlined,
    Menu,
    MenuItem: Menu.Item,
    SalaryDetail,
    SalaryEdit,
    GeneralSalary,
    DownloadCommissionPayment,
    NewSalaryEdit,
    DownloadSelectPrintDate,
    DatePicker,
  },
  data() {
    return {
      searchForm: {
        search:""
      },
      tablePagination: {
        pageSizeOptions: ["10", "20", "50", "100"],
        showSizeChanger: true,
        current: 1,
        pageSize: 10,
        total: 0,
      },
      selectedRowKeys:[],
      loading: false,
      list: [],
      columns: [
          // { title: this.$t("salary.table.id_sal"), fixed: "left", dataIndex: "idSal", key: "idSal" },
	  { title: this.$t("salary.table.month"), dataIndex: "month", key: "month" },
          { title: this.$t("salary.table.id_adv"), dataIndex: "advisorName", key: "advisorName" },
          { title: this.$t("salary.table.total_fyc"), dataIndex: "totalFyc", key: "totalFyc" },
          { title: this.$t("salary.table.total_renewal"), dataIndex: "totalRenewal", key: "totalRenewal", customRender: ({text}) =>{
              return this.money(text)
          } },
          { title: this.$t("salary.table.contribution"), dataIndex: "contribution", key: "contribution", customRender: ({text}) =>{
              return this.money(text)
          } },
          { title: this.$t("salary.table.overide"), dataIndex: "overide", key: "overide", customRender: ({text,record}) =>{
              if(record.showOverride === null){
                return this.money(text)
              }else{
                return this.money(record.showOverride)
              }
              
          } },
          { title: this.$t("salary.table.extra_bonus"), dataIndex: "extraBonus", key: "extraBonus", customRender: ({text}) =>{
              return this.money(text)
          } },
          { title: this.$t("salary.table.extra_commission"), dataIndex: "extraCommission", key: "extraCommission", customRender: ({text, record}) =>{
              return this.money(record.extraCommission)
          } },
          { title: this.$t("salary.table.total_subject"), dataIndex: "totalSubject", key: "totalSubject", customRender: ({text}) =>{
              return this.money(text)
          } },
          { title: this.$t("salary.table.others"), dataIndex: "others", key: "others", customRender: ({text}) =>{
              return this.money(text)
          } },
          { title: this.$t("salary.table.confirm_date"), dataIndex: "paymentDate", key: "paymentDate", customRender: ({text}) =>{
            if(text){
              return moment(text).format('YYYY-MM-DD')
            }
            
          }},
          // { title: this.$t("salary.table.payment_date"), dataIndex: "paymentDate", key: "paymentDate", customRender: ({text}) =>{
          //   if(text){
          //     return moment(text).format('YYYY-MM-DD')
          //   }
            
          // }},

        { key: "action", fixed: "right", slots: { title: "actionTitle", customRender: "action" } },
      ],
      selectList:{
        advisorList: [],
      }
    };
  },
  methods: {
    chang_page(pagination) {
      this.tablePagination = pagination;
      this.get_list();
    },
    get_list() {
      this.loading = true;
      const api = new SalaryList();
      const getData = {
        page: this.tablePagination.current,
        limit: this.tablePagination.pageSize,
      }
      if (this.searchForm.search != "") getData.search = this.searchForm.search
      if (this.searchForm.month) getData.month = this.searchForm.month
      // if (this.searchForm.order != "") getData.order = this.searchForm.order
      api
        .get(getData)
        .then((response) => {
          this.loading = false;
          if (0 === parseInt(response.data.code)) {
            const dataTmp = response.data.data;
            this.tablePagination.current = parseInt(dataTmp.current);
            this.tablePagination.pageSize = parseInt(dataTmp.pageSize);
            this.tablePagination.total = parseInt(dataTmp.total);
            this.list = dataTmp.data;
          } else {
            this.list = [];
          }
        });
    },
    add() {
      this.$refs.refNewSalaryEdit.addShow();
    },
    detail(obj) {
      this.$refs.refSalaryDetail.detailShow(obj);
    },
    edit(obj) {
      // this.$refs.refSalaryEdit.editShow(obj);
      this.$refs.refNewSalaryEdit.editShow(obj);
    },
    del(idSal) {
      Modal.confirm({
        title: this.$t("public.name.are_you_sure_delete") + "?",
        content: this.$t("public.name.action_cannot_resumed"),
        icon: createVNode(ExclamationCircleOutlined),
        okText: this.$t("public.name.yes"),
        okType: "danger",
        cancelText: this.$t("public.name.no"),
        onOk: () => {
          const api = new SalaryDelete();
          api.post({ idSal: idSal }).then((response) => {
            if (0 === parseInt(response.data.code)) {
              this.get_list();
              message.success(response.data.msg);
            } else {
              message.error(response.data.msg);
            }
          });
        },
      });
    },
    confirm(idSal) {
      Modal.confirm({
        title: this.$t("public.name.are_you_sure_confirm") + "?",
        content: this.$t("public.name.action_cannot_resumed"),
        icon: createVNode(ExclamationCircleOutlined),
        okText: this.$t("public.name.yes"),
        okType: "danger",
        cancelText: this.$t("public.name.no"),
        onOk: () => {
            const api = new SalaryConfirm();
            api.post({ idSal: idSal }).then((response) => {
              if (0 === parseInt(response.data.code)) {
                this.get_list();
                message.success(response.data.msg);
              } else {
                message.error(response.data.msg);
              }
            });
        },
      });
    },
    search_submit() {
      this.get_list()
    },
    generalSalary(){
      this.$refs.refGeneralSalary.addShow();
    },
    download(idSal,printDate){
     
      const api = new SalaryDownload();
      api.download({
        idSal:idSal,
        printDate
      }).then((response) => {
        if (!response) {
          return
        }
        if(response.data.type == 'application/json'){
          message.error(this.$t("public.name.no_data"))
          return
        }
      
        let url = window.URL.createObjectURL(new Blob([response.data]))
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', response.headers.filename)
        document.body.appendChild(link)
        link.click()
      });
    },
    downloadCommissionPayment(){
      if(this.selectedRowKeys.length == 0){
        message.info('Please Select')
        return 
      }
      this.$refs.refDownloadCommissionPayment.show();
    },
    downloadCommissionPaymentStart(e){
      console.log(e)
      
      for(let i = 0;i < this.selectedRowKeys.length;i ++){
        this.downloadCommissionPaymetDown(this.selectedRowKeys[i],e.printDate)
      }
    },
    downloadCommissionPaymetDown(idSal,printDate){
      const api = new PaymentDownCommissionPaymentByIdSal();
          api.download({
            idSal:idSal,
            // month:month,
            printDate:printDate
          }).then((response) => {
            if (!response) {
              return
            }
            if (response.data.type == 'application/json') {
              message.error(this.$t("public.name.no_data"))
              return
            }
            let url = window.URL.createObjectURL(new Blob([response.data]))
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download',  response.headers.filename)
            document.body.appendChild(link)
            link.click()
          });
    },
    onSelectChange(selectedRowKeys){
      this.selectedRowKeys = selectedRowKeys;
      console.log(this.selectedRowKeys)
    },
    downloadAdvisor(){
      if(this.selectedRowKeys.length == 0){
        message.info('Please Select')
        return 
      }
      this.$refs.refDownloadSelectPrintDate.show();
    },
    downloadAdvisorStart(printDate){
      console.log(printDate)
      for(let i = 0;i < this.selectedRowKeys.length;i ++){
        this.download(this.selectedRowKeys[i],printDate)
      }
      
    },
    downloadAdvisorExcel() {
      if(this.selectedRowKeys.length == 0){
        message.info('Please Select')
        return 
      }
      const api = new SalaryExport();
      for(let i = 0;i < this.selectedRowKeys.length;i ++){
        const getData = {
          idSal:this.selectedRowKeys[i]
      }
      api
        .download(getData)
        .then((response) => {
          // console.log(decodeURI(res.headers['filename']));
          let blob = new Blob([response.data], { type: "application/xlsx" });
          let url = window.URL.createObjectURL(blob);
          const link = document.createElement("a"); // 创建a标签
          link.href = url;
          link.download = decodeURI(response.headers['filename']); // 重命名文件
          link.click();
          URL.revokeObjectURL(url);
        });
      }
    },
    downloadPaymentCommissionExcel() {
      if(this.selectedRowKeys.length == 0){
        message.info('Please Select')
        return 
      }
      const api = new PaymentExportCommissionPaymentByIdSal();
      for(let i = 0;i < this.selectedRowKeys.length;i ++){
        const getData = {
          idSal:this.selectedRowKeys[i]
      }
      api
        .download(getData)
        .then((response) => {
          // console.log(decodeURI(res.headers['filename']));
          let blob = new Blob([response.data], { type: "application/xlsx" });
          let url = window.URL.createObjectURL(blob);
          const link = document.createElement("a"); // 创建a标签
          link.href = url;
          link.download = decodeURI(response.headers['filename']); // 重命名文件
          link.click();
          URL.revokeObjectURL(url);
        });
      }
      
    },
    search_reset() {
      this.searchForm = {
        // search: "",
        // status: 0,
        // order: "",
      }
      this.get_list()
    }
  },
  mounted() {
    this.get_list();
  },
}
</script>

<style lang="less">
@import url("~@/assets/less/home/salary.less");
</style>